import {
    Container,
    Stack,
    Heading,
    Flex,
    Text,
} from '@chakra-ui/react';
import { CollectionForm } from '../components/CollectionForm';
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from '../services/firebase/config';
import { useForm } from '../hooks/useForm';

import Swal from "sweetalert2"

export const NewCollection = () => {

    const [formValues, handleInputChange, reset] = useForm({
        id: new Date().getDate(),
        title: "",
        description: "",
        cover: "",
        category: "",
        url: "",
        stargazers_count: 0
    });

    const { title, description, category, url, cover } = formValues;

    const handleSudmit = (e) => {
        e.preventDefault();

        if (!title.length >= 6 && !description.length >= 6 && category !== "") {
            return Swal.fire({
                icon: "error",
                title: "Oops... &#128533;",
                text: 'Something went wrong!',
                footer: "check the fields"
            });
        }

        if (url === "") {
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                footer: 'Check the url'
            });
        }

        const docREf = doc(db, "webcollections", category);
        updateDoc(docREf, {
            webs: arrayUnion(formValues)
        });
        reset();

    }

    return (
        <Container maxW="7xl" py={10} px={{ base: 5, md: 8 }}>
            <Stack spacing={10}>
                <Flex align="center" justify="center" direction="column">
                    <Heading fontSize="4xl" mb={2}>
                        Add  to a Collection
                    </Heading>
                    <Text fontSize="md" textAlign="center">
                        Don't forget to add the reference image url copy and paste it into the form cover
                    </Text>
                </Flex>
                <CollectionForm
                    handleSudmit={handleSudmit}
                    handleInputChange={handleInputChange}
                    title={title}
                    description={description}
                    category={category}
                    url={url}
                    cover={cover}
                />
            </Stack>
        </Container>
    );
};

